var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReelsLikes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 30,
    height: 30,
    rx: 5,
    fill: "#FFDCE7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5003 23.0413C15.242 23.0413 14.992 23.008 14.7837 22.933C11.6003 21.8413 6.54199 17.9663 6.54199 12.2413C6.54199 9.32467 8.90033 6.95801 11.8003 6.95801C13.2087 6.95801 14.5253 7.50801 15.5003 8.49134C16.4753 7.50801 17.792 6.95801 19.2003 6.95801C22.1003 6.95801 24.4587 9.33301 24.4587 12.2413C24.4587 17.9747 19.4003 21.8413 16.217 22.933C16.0087 23.008 15.7587 23.0413 15.5003 23.0413ZM11.8003 8.20801C9.59199 8.20801 7.79199 10.0163 7.79199 12.2413C7.79199 17.933 13.267 21.0997 15.192 21.758C15.342 21.808 15.667 21.808 15.817 21.758C17.7337 21.0997 23.217 17.9413 23.217 12.2413C23.217 10.0163 21.417 8.20801 19.2087 8.20801C17.942 8.20801 16.767 8.79967 16.0087 9.82467C15.7753 10.1413 15.242 10.1413 15.0087 9.82467C14.2337 8.79134 13.067 8.20801 11.8003 8.20801Z",
    fill: "#DC1F5C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReelsLikes);
export default __webpack_public_path__ + "static/media/reels_likes.ffc1864ffecfcc4feff42018be65ec3a.svg";
export { ForwardRef as ReactComponent };